import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 5D23E65D-271A-463B-972F-E8524E76E6D7
 * name dots-vertical-circle
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dots-vertical-circle.svg
 * tags
 */
export const DotsVerticalCircleIcon = createSvgIcon(<><path d="M2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12M10.5,12A1.5,1.5 0 0,0 12,13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 12,10.5A1.5,1.5 0 0,0 10.5,12M10.5,17.5A1.5,1.5 0 0,0 12,19A1.5,1.5 0 0,0 13.5,17.5A1.5,1.5 0 0,0 12,16A1.5,1.5 0 0,0 10.5,17.5M10.5,6.5A1.5,1.5 0 0,0 12,8A1.5,1.5 0 0,0 13.5,6.5A1.5,1.5 0 0,0 12,5A1.5,1.5 0 0,0 10.5,6.5Z" /></>, 'DotsVerticalCircleIcon');
export default DotsVerticalCircleIcon